// Get Performance Tags
export const GET_PERFORMANCE_TAGS_REQUEST = 'GET_PERFORMANCE_TAGS_REQUEST';
export const GET_PERFORMANCE_TAGS_DONE = 'GET_PERFORMANCE_TAGS_DONE';
export const GET_PERFORMANCE_TAGS_FAILED = 'GET_PERFORMANCE_TAGS_FAILED';